import React, { Fragment } from 'react';
import { Grid, Divider } from 'semantic-ui-react';
import { map } from 'lodash';
import { renderDataAsHtml, renderDataAsPlainText } from '../../api/renderPrismicData';
import withDataFetch from '../../api/withDataFetch';
import withFullScreenLoader from '../UtilityComponents/withFullScreenLoading';
import './Contact.css';

const Contact = ({
  data: {
    title,
    contact,
  },
}) => {
  return (
    <Grid stackable className="Contact">
      <Grid.Row centered>
        <h2 className="Page__Title">
          {renderDataAsPlainText(title)}
        </h2>
      </Grid.Row>
      <Divider />
      <Grid.Row>
        {map(contact, ({ title: subTitle, content }, index) => {
          return (
            <Fragment key={title}>
              <Grid.Column width={8}>
                {renderDataAsHtml(subTitle)}
                {renderDataAsHtml(content)}
              </Grid.Column>
              {index % 2 === 1 && (
                <Grid.Column only="computer tablet" width={16}>
                  <Divider />
                </Grid.Column>
              )}
            </Fragment>
          );
        })}
      </Grid.Row>
      <Divider />
    </Grid>
  );
};

export default withDataFetch(withFullScreenLoader(Contact), 'contact');



// WEBPACK FOOTER //
// ./src/components/Contact/index.js